import {i18n} from "core/localization";


let entityDataSource: {label: string, value: string}[]
export function getEntityDataSource() {
	if (entityDataSource == null) {
		entityDataSource = [{
			label: i18n('Asset'),
			value: 'asset'
		},{
			label: i18n('Asset Group'),
			value: 'assetGroup'
		},{
			label: i18n('Service'),
			value: 'service'
		},{
			label: i18n('Sla'),
			value: 'sla'
		},{
			label: i18n('Metric'),
			value: 'metric'
		},{
			label: i18n('Kpi'),
			value: 'kpi'
		},{
			label: i18n('Cost'),
			value: 'cost'
		},{
			label: i18n('Incident'),
			value: 'incident'
		}];

		entityDataSource.sort((a, b) => a.label.localeCompare(b.label))

		entityDataSource.splice(0, 0, {
			label: i18n('None'),
			value: 'none'
		})
	}

	return entityDataSource;
}
